<template>
    <div class="brt-map-LogoMoudle" ref="logoMoudle">
        <!--../../../../../../public/images/logo.png-->
        <a><img :src="LOGO"></a>
    </div>
</template>

<script>
    export default {
        name: "LogoModule",

        data(){
            return {
                LOGO:JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.apply).mapLogo
            }
        }
    }
</script>

<style lang="less">
    @import "../../../../../styles/cssBlock.less";
    .brt-map-LogoMoudle{

        padding-left: @standartSpaceA5;
        flex: 1;

        >a{
           >img{
               height: @standartHeightA4;
               width:  @standartHeightA4;
           }
        }
    }
</style>

